import AbstractRepository from "@/repositories/AbstractRepository";
import { Document } from "@/repositories/FileRepository";

export interface Comment {
    uuid: string;
    documents: Document[];
    createdBy: {
        displayName: string,
    };
}

export default class RequestCommentRepository extends AbstractRepository {
    protected static resource: string = "ptf-request-requestcomment";

    protected static defaultFields: string[] = [
        "uuid",
        "request.uuid",
        "commentary",
        "documents.uuid",
        "documents.clientOriginalFileName",
        "documents.type",
        "documents.link",
    ];
}
